export default "__VITE_ASSET__940627cb__"